<template>
  <div>
    <vs-sidebar
      parent="#chat-app"
      position-right
      :hidden-background="true"
      default-index="1"
      color="primary"
      class="items-no-padding"
      spacer
      v-model="activeSidebarRecords"
    >
      <!-- {{records}} -->
      <!-- <vs-button @click="activeSidebarRecords = false" color="primary" type="filled">Open Sidebar</vs-button> -->
      <div class="flex justify-between items-center p-2">
        <feather-icon
          icon="XIcon"
          class="bg-white p-2 shadow-md rounded-full mr-5 cursor-pointer"
          svgClasses="w-6 h-6"
          @click="activeSidebarRecords = false"
        ></feather-icon>

        <vs-button color="success" type="border" @click="active = true">{{$t(`DATASOURCEVIEW.btnCreateOrigin`)}}</vs-button>
      </div>      

      <div class="w-full overflow-auto height-table border border-solid border-l-0 border-r-0 border-b-0 d-theme-border-grey-light">
        <table collapse="1" class="border-collapse">
          <thead class=" sticky top-0 bg-white">
            <!-- <th class="border border-solid border-t-0 d-theme-border-grey-light">item</th> -->
            <th class="p-2 text-center border border-solid border-t-0 border-b-0 d-theme-border-grey-light" v-for="(head, index) in HEADERS" :key="index">{{head}}</th>           
          </thead>
          <tbody>
              <tr class="" v-for="(record, i) in records" :key="i">
                  <td class=" border border-solid border-t-0 border-l-0 text-center d-theme-border-grey-light p-2">{{i + 1}}</td>
                  <td class="p-1 border border-solid border-t-0 text-center d-theme-border-grey-light" v-for="(item, j) in record" :key="j">{{item}}</td>                 
              </tr>
          </tbody>
        </table>
      </div>
    </vs-sidebar>

    <popupCteateOrigen :popupActive="active" @popupActive="active = $event"></popupCteateOrigen>
  </div>
</template>

<script>
import { mapState, mapWritableState, mapActions } from "pinia";
import { useConnStore } from "./store";
import popupCteateOrigen from "./popupCreateOrigen.vue";

export default {
  components: { popupCteateOrigen },
  data: () => ({
    active: false
  }),
  methods: {
    ...mapActions(useConnStore, ["stateSidebar"])
  },
  computed: {
    ...mapWritableState(useConnStore, ["activeSidebarRecords"]),
    ...mapState(useConnStore, ["records", "HEADERS"]),   
  }
};
</script>

<style lang="scss">
#chat-app .vs-sidebar {
  max-width: calc(100% - 402px);

  .height-table {
    height: calc(100% - 53px);
  }

  thead::before {
    content: "";
    width: 100%;
    height: 1px;
    border: 1px solid #dae1e7;
    border-top: 0px;
    border-left: 0px;
    border-right: 0px;
    position: absolute;
   bottom: 0px;
  }
  .vs-sidebar--items {
    overflow: auto !important;
  }

  @media only screen and (max-width: 900px) {
    max-width:  calc(100% - 302px);;
  }

  @media only screen and (max-width: 400px) {
    max-width:  100%;
  }
}
</style>
